import { useEffect } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { captureMessage } from 'src/utils/lib/sentry';
import {
  PerformanceStore,
  usePerformanceActions,
  usePerformanceChannelData,
  isCopiesExtractionError,
} from 'src/store';
import { useErrorHandler } from 'src/hooks';
import { INTEGRATION_CHANNELS, RESOURCE_CHANNELS } from 'src/data/performance';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['connectedAccountsFetched']);

export const useGetChannelLastExtraction = (channel) => {
  const handleError = useErrorHandler();
  const performanceActions = usePerformanceActions();
  const { selectedAccountIds, extractingCopies } = usePerformanceChannelData(channel);
  const { connectedAccountsFetched } = usePerformanceState();

  useEffect(() => {
    if (!connectedAccountsFetched || !INTEGRATION_CHANNELS.includes(channel)) {
      return;
    }
    if (selectedAccountIds.length === 0 || extractingCopies) {
      performanceActions.setLoadingConnectedAccounts(false);
      return;
    }
    performanceActions.getChannelLastExtraction(channel).catch((error) => {
      if (isCopiesExtractionError(error)) {
        captureMessage('Auth error getting channel last extraction', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'useGetChannelLastExtraction',
          },
        });
      } else {
        handleError(error);
      }
    });
  }, [
    handleError,
    connectedAccountsFetched,
    selectedAccountIds,
    performanceActions,
    channel,
    extractingCopies,
  ]);

  useEffect(() => {
    if (!connectedAccountsFetched || !RESOURCE_CHANNELS.includes(channel)) {
      return;
    }
    if (extractingCopies) {
      performanceActions.setLoadingConnectedAccounts(false);
      return;
    }
    performanceActions.getChannelLastExtraction(channel).catch((error) => {
      if (isCopiesExtractionError(error)) {
        captureMessage('Auth error getting channel last extraction', {
          level: 'warning',
          extra: {
            error: error.toString(),
            source: 'useGetChannelLastExtraction',
          },
        });
      } else {
        handleError(error);
      }
    });
  }, [handleError, connectedAccountsFetched, performanceActions, channel, extractingCopies]);
};
